import React from "react";
import BasicModal from "../../_widgets/Modal/BasicModal";
import { Col, Form, Row } from "react-bootstrap";
import Input from "../../_widgets/Input/Input";
import { warn } from "../../../Wrapper/toast/toast";
import { MAX_30_CHARS, MAX_50_CHARS } from "../../../Constants/stringConstants";

const EditApplicationsModal = ({
  modalShow,
  setModalShow,
  handleClose,
  addApplicationData,
  addApplication,
  editApplication,
  buttonLoading,
  setAddApplicationData,
}) => {
  return (
    <BasicModal
      show={modalShow}
      size="md"
      setModalShow={setModalShow}
      handleClose={handleClose}
      heading={`${addApplicationData.action} Application`}
      footer
      button2Text="Save"
      button2Click={() =>
        addApplicationData.action === "Add"
          ? addApplication()
          : editApplication(addApplicationData.id)
      }
      loading={buttonLoading}
    >
      <div className="patients_ui">
        <Row>
          <Col xl={12}>
            <div className="white_card text-start">
              <Row className="mb-3">
                <Col lg={12}>
                  <Input
                    isRequired={true}
                    placeholder="Enter Application Name"
                    type="text"
                    label="Application Name"
                    value={addApplicationData?.name}
                    onChange={(e) => {
                      if (e.target.value.length <= 50) {
                        setAddApplicationData({
                          ...addApplicationData,
                          name: e.target.value,
                        });
                      } else {
                        warn(MAX_50_CHARS);
                      }
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col lg={12}>
                  <Form.Group as={Col} md={12} className="mb-3">
                    <Form.Label>Description </Form.Label>
                    <Input
                      type="text"
                      name="description"
                      value={addApplicationData.description}
                      onChange={(e) => {
                        if (e.target.value.length <= 50) {
                          setAddApplicationData({
                            ...addApplicationData,
                            description: e.target.value,
                          });
                        } else {
                          warn(MAX_50_CHARS);
                        }
                      }}
                      placeholder="Enter description"
                      maxLength={MAX_50_CHARS}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
    </BasicModal>
  );
};

export default EditApplicationsModal;
